import transferir from '@/core/store/item-ata/transferencia/transferir'
import historico from '@/core/store/item-ata/transferencia/historico'

export default {
	modules: {
		transferir,
		historico,
	},
}
